import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild, CanLoad, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizeService } from '../services/auth/authorize.service';
import { tap } from 'rxjs/operators';
import { ApplicationPaths, QueryParameterNames } from '../authorization/api-authorization.constants';
import { environment } from '@env/environment';
import { Permission } from '@app/shared/models/Authentication/permission.model';
import { AccountService } from '../services/Common/account.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(private authorize: AuthorizeService, private router: Router, private accountService: AccountService) {
  }


  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authorize.isAuthenticated()
      .pipe(tap(isAuthenticated => this.handleAuthorization(isAuthenticated, state)));
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {

    const url = `/${route.path}`;
    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {

    if (this.authorize.isAuthenticated) {
      return true;
    }
    this.router.navigate([environment.loginUrl]);
    return false;
  }

  private handleAuthorization(isAuthenticated: boolean, state: RouterStateSnapshot) {

    if (!isAuthenticated) {
      this.router.navigate(ApplicationPaths.LoginPathComponents, {
        queryParams: {
          [QueryParameterNames.ReturnUrl]: state.url
        }
      });
    }
  }

  // get hasAdminRights() {
  //   return this.accountService.userHasPermission(Permission.IsSuperAdmin);
  // }
  // get hasComparatorRights() {
  //   return this.accountService.userHasPermission(Permission.viewComparatorUI);
  // }
  // hasHealthRights() {
  //   return this.accountService.userHasPermission(Permission.IsHealthUser);
  // }
  // get hasLifeRights() {
  //   return this.accountService.userHasPermission(Permission.IsLifeUser);
  // }
}
